import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import policyAuthorizations from 'modules/permissions/store/collections/policyAuthorizations'

interface Props {
  onCloseModal: () => void
}

const PayrollSetupWarning = ({ onCloseModal }: Props) => {
  policyAuthorizations.authorizePolicies('payroll_supplements.supplements.create')
  const canEditSupplements = policyAuthorizations.for('payroll_supplements.supplements.create')
  const { navigation } = useNavigation()

  const trackEvent = () => {
    track(trackingEvents.timeTracking.activatePayrollFromCompensation, {})
  }

  const compensateButtons = () => {
    if (canEditSupplements) {
      return (
        <Box flexDirection="row" gap="s8">
          <Button type="secondary" onClick={onCloseModal}>
            {i18n.t('clock_in.sidepanel.compensation.modal.payroll_warning.do_later')}
          </Button>
          <Button.Router
            onClick={trackEvent}
            type="primary"
            to={navigation.payrollBundle.fullPath()}
          >
            {i18n.t('clock_in.sidepanel.compensation.modal.payroll_warning.activate_payroll')}
          </Button.Router>
        </Box>
      )
    }

    return (
      <Button type="secondary" onClick={onCloseModal}>
        {i18n.t('common.ok')}
      </Button>
    )
  }

  return (
    <Modal
      illustration="alert"
      title={i18n.t('clock_in.sidepanel.compensation.modal.payroll_warning.title')}
      description={
        canEditSupplements
          ? i18n.t(
              'clock_in.sidepanel.compensation.modal.payroll_warning.enabled_permission_description'
            )
          : i18n.t(
              'clock_in.sidepanel.compensation.modal.payroll_warning.disabled_permission_description'
            )
      }
      footer={compensateButtons()}
      onClose={onCloseModal}
    ></Modal>
  )
}

export default PayrollSetupWarning
